import $ from 'jquery';

const $window = $(window);
const $page = $('.page');
const $content = $('.page__content');
const $navTop = $('.navigation__top');
const $navTopContainer = $('.navigation__top-container');
let pageIsTop = true;

$(function () {
    pageScrolled();
    $window.on('scroll:down', pageScrollDown);
    $window.on('scroll:up', pageScrollUp);
});

const pageScrolled = () => {
    if ($content.scrollTop() > 0) {
        pageScrolledHandler(true);
    } else {
        pageTopHandler(true);
    }
};

const pageScrollDown = () => {
    if ($content.scrollTop() > 0) {
        pageScrolledHandler();
    }
};

const pageScrollUp = () => {
    if ($content.scrollTop() < 50) {
        pageTopHandler();
    }
};

const pageScrolledHandler = (force = false) => {
    if (pageIsTop === true || force === true) {
        pageIsTop = false;
        $page.addClass('scrolled');
        $navTopContainer.stop().animate({ opacity: 0 }, 150);
        $navTop.stop().slideUp(300);
    }
};

const pageTopHandler = (force = false) => {
    if (pageIsTop === false || force === true) {
        pageIsTop = true;
        $page.removeClass('scrolled');
        $navTop.stop().slideDown(300, function () {
            $navTopContainer.stop().animate({ opacity: 1 }, 150);
        });
    }
};
